var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region ScheduleDetailDay - Ctor
    ns.ScheduleDetailDay = function ScheduleDetail(day, scheduleWeeks, isoWeekday, scheduleDetail) {
        this.parentDetail = scheduleDetail;
        this.day = day;
        this.dayOfWeek = isoWeekday;
        this.scheduleWeeks = scheduleWeeks;

        this.onDataSourceChange();
    }
    // #endregion

    // #region StudentDetailDay - Inheritance

    ns.ScheduleDetailDay.prototype = new ns.ScheduleDayBase();
    ns.ScheduleDetailDay.prototype.constructor = ns.ScheduleDetailDay;
    ns.ScheduleDetailDay.prototype.parent = ns.ScheduleDayBase.prototype;

    // #endregion

    // #region ScheduleDetailDay - Methods
    ns.ScheduleDetailDay.prototype.calculateProperties = function () {

        this.daySchedules = this.getSchedulesByDay(this.scheduleWeeks, this.dayOfWeek);

        this._firstPeriodStartDate = this.getTimeValue(this.daySchedules, 'firstPeriodStartDate', true);
        this._firstPeriodEndDate = this.getTimeValue(this.daySchedules, 'firstPeriodEndDate', false);
        this._secondPeriodStartDate = this.getTimeValue(this.daySchedules, 'secondPeriodStartDate', true);
        this._secondPeriodEndDate = this.getTimeValue(this.daySchedules, 'secondPeriodEndDate', false);
        this._lunch = this.getBoolValue(this.daySchedules, 'lunch');
        this._firstSnack = this.getBoolValue(this.daySchedules, 'firstSnack');
        this._secondSnack = this.getBoolValue(this.daySchedules, 'secondSnack');
        this._notes = this.getStringValue(this.daySchedules, 'notes');
        this._firstPeriodCapacity = this.getNumberValue(this.daySchedules, 'firstPeriodCapacity');
        this._secondPeriodCapacity = this.getNumberValue(this.daySchedules, 'secondPeriodCapacity');

        this.firstPeriodStartDateIndeterminate = this.isTimeIndeterminate(this.scheduleWeeks, 'firstPeriodStartDate');
        this.firstPeriodEndDateIndeterminate = this.isTimeIndeterminate(this.scheduleWeeks, 'firstPeriodEndDate');
        this.secondPeriodStartDateIndeterminate = this.isTimeIndeterminate(this.scheduleWeeks, 'secondPeriodStartDate');
        this.secondPeriodEndDateIndeterminate = this.isTimeIndeterminate(this.scheduleWeeks, 'secondPeriodEndDate');
        this.lunchIndeterminate = this.isBoolIndeterminate(this.scheduleWeeks, 'lunch');
        this.firstSnackIndeterminate = this.isBoolIndeterminate(this.scheduleWeeks, 'firstSnack');
        this.secondSnackIndeterminate = this.isBoolIndeterminate(this.scheduleWeeks, 'secondSnack');
        this.notesIndeterminate = this.isStringIndeterminate(this.scheduleWeeks, 'notes');
        this.firstPeriodCapacityIndeterminate = this.isNumberIndeterminate(this.scheduleWeeks, 'firstPeriodCapacity');
        this.secondPeriodCapacityIndeterminate = this.isNumberIndeterminate(this.scheduleWeeks, 'secondPeriodCapacity');

        this.firstPeriodStartDateMin = this.getUnboundedMinTimeValue().toDate();
        this.firstPeriodEndDateMax = this.getUnboundedMaxTimeValue().toDate();
        this.secondPeriodStartDateMin = this.getUnboundedMinTimeValue().toDate();
        this.secondPeriodEndDateMax = this.getUnboundedMaxTimeValue().toDate();

        this._active = (!!this.firstPeriodStartDate && !!this.firstPeriodEndDate) ||
                       (!!this.secondPeriodStartDate && !!this.secondPeriodEndDate);
    }

    ns.ScheduleDetailDay.prototype.getTimeValue = function (daySchedules, propertyName, min) {
        if (!daySchedules || !daySchedules.length) {
            return null;
        }

        if (min) {
            return this.getMinTimeValue(daySchedules, propertyName, true);
        } else {
            return this.getMaxTimeValue(daySchedules, propertyName, true);
        }

        return null;
    }

    ns.ScheduleDetailDay.prototype.getBoolValue = function (daySchedules, propertyName) {
        if (!daySchedules || !daySchedules.length) {
            return null;
        }

        for (var d = 0; d < daySchedules.length; d++) {
            var prop = daySchedules[d][propertyName];
            if (prop) {
                return true;
            }
        }

        return false;
    }

    ns.ScheduleDetailDay.prototype.getStringValue = function (daySchedules, propertyName) {
        if (!daySchedules || !daySchedules.length) {
            return null;
        }

        var val = null;
        var first = true;

        for (var d = 0; d < daySchedules.length; d++) {
            var prop = daySchedules[d][propertyName];
            if (first) {
                first = false;
                val = prop;
            } else {
                if (val !== prop) {
                    return null;
                }
            }
        }

        return val;
    }

    ns.ScheduleDetailDay.prototype.getNumberValue = function (daySchedules, propertyName) {
        if (!daySchedules || !daySchedules.length) {
            return null;
        }

        var val = null;
        var first = true;

        for (var d = 0; d < daySchedules.length; d++) {
            var prop = daySchedules[d][propertyName];
            if (first) {
                first = false;
                val = prop;
            } else {
                if (val > prop) {
                    val = prop;
                }
            }
        }

        return val;
    }

    ns.ScheduleDetailDay.prototype.isTimeIndeterminate = function (scheduleWeeks, propertyName) {

        if (!scheduleWeeks ||
            !scheduleWeeks.length) {
            return false;
        }

        var first = true;
        var val = null;
        var rDate = null;
        var rMin = null;

        for (var s = 0; s < scheduleWeeks.length; s++) {
            var activityWeek = scheduleWeeks[s];

            var schedule = activityWeek.getScheduleByDay(this.dayOfWeek);
            if (!schedule) {
                if (!first) {
                    if (!!val) {
                        return true;
                    }
                }

                first = false;
                continue;
            }

            var rvalue = schedule[propertyName];

            if (first) {
                if (rvalue) {
                    rDate = moment(rvalue);
                    rMin = rDate.hours() * 60 + rDate.minutes();
                    val = rMin;
                }
                first = false;
            } else {
                if (rvalue) {
                    rDate = moment(rvalue);
                    rMin = rDate.hours() * 60 + rDate.minutes();
                    if (val !== rMin) {
                        return true;
                    }
                } else {
                    if (val === null && !!rvalue) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    ns.ScheduleDetailDay.prototype.isBoolIndeterminate = function (scheduleWeeks, propertyName) {
        if (!scheduleWeeks ||
            !scheduleWeeks.length) {
            return false;
        }

        var first = true;
        var val = null;

        for (var s = 0; s < scheduleWeeks.length; s++) {
            var activityWeek = scheduleWeeks[s];

            var schedule = activityWeek.getScheduleByDay(this.dayOfWeek);

            if (!schedule) {
                if (!first) {
                    if (val) {
                        return true;
                    }
                }

                first = false;
                val = false;
                continue;
            }

            var rvalue = schedule[propertyName];

            if (first) {
                val = rvalue;
                first = false;
            } else {
                if (rvalue !== val) {
                    return true;
                }
            }
        }

        return false;
    }

    ns.ScheduleDetailDay.prototype.isStringIndeterminate = function (scheduleWeeks, propertyName) {
        if (!scheduleWeeks ||
            !scheduleWeeks.length) {
            return false;
        }

        var first = true;
        var val = null;

        for (var s = 0; s < scheduleWeeks.length; s++) {
            var activityWeek = scheduleWeeks[s];

            var schedule = activityWeek.getScheduleByDay(this.dayOfWeek);
            if (!schedule) {
                if (!first) {
                    if (!String.prototype.isNullOrWhitespace(val)) {
                        return true;
                    }
                }

                first = false;
                continue;
            }

            var rvalue = schedule[propertyName];
            if (first) {
                val = rvalue;
                first = false;
            } else {
                var differ = (!String.prototype.isNullOrWhitespace(rvalue) && !String.prototype.isNullOrWhitespace(val) && (rvalue !== val)) ||
                             (String.prototype.isNullOrWhitespace(rvalue) !== String.prototype.isNullOrWhitespace(val));
                if (differ) {
                    return true;
                }
            }
        }
        return false;
    }

    ns.ScheduleDetailDay.prototype.isNumberIndeterminate = function (scheduleWeeks, propertyName) {
        if (!scheduleWeeks ||
            !scheduleWeeks.length) {
            return false;
        }

        var first = true;
        var val = null;

        for (var s = 0; s < scheduleWeeks.length; s++) {
            var activityWeek = scheduleWeeks[s];

            var schedule = activityWeek.getScheduleByDay(this.dayOfWeek);
            if (!schedule) {
                if (!first) {
                    if (val) {
                        return true;
                    }
                }

                first = false;
                continue;
            }

            var rvalue = schedule[propertyName];
            if (first) {
                val = rvalue;
                first = false;
            } else {
                if (rvalue !== val) {
                    return true;
                }
            }
        }
        return false;
    }

    ns.ScheduleDetailDay.prototype.onDataSourceChange = function () {
        this.calculateProperties();
    }

    ns.ScheduleDetailDay.prototype.applyChanges = function () {
        if (this.scheduleWeeks) {

            var hasFirstPeriod = (!!this.firstPeriodStartDate && !!this.firstPeriodEndDate);
            var hasSecondPeriod = (!!this.secondPeriodStartDate && !!this.secondPeriodEndDate);
            var shouldRemove = !hasFirstPeriod && !hasSecondPeriod;
            var week = null;

            if (shouldRemove) {
                this.firstPeriodStartDateChanged = false;
                this.firstPeriodEndDateChanged = false;
                this.secondPeriodStartDateChanged = false;
                this.secondPeriodEndDateChanged = false;
                this.lunchChanged = false;
                this.firstSnackChanged = false;
                this.secondSnackChanged = false;
                this.notesChanged = false;
                this.firstPeriodCapacityChanged = false;
                this.secondPeriodCapacityChanged = false;

                for (var w = 0; w < this.scheduleWeeks.length; w++) {
                    week = this.scheduleWeeks[w];
                    week.removeScheduleByDay(this.dayOfWeek);
                }
            } else {

                for (var w = 0; w < this.scheduleWeeks.length; w++) {
                    week = this.scheduleWeeks[w];
                    var schedule = week.getScheduleByDay(this.dayOfWeek);

                    if (!schedule) {
                        schedule = {
                        };
                    }

                    var isDirty = false;

                    if (hasFirstPeriod) {
                        if (this.firstPeriodStartDateChanged) {
                            this.applyChangesToTimeProperty(week.startDate, schedule, this.firstPeriodStartDate, 'firstPeriodStartDate');
                            isDirty = true;
                        }
                        if (this.firstPeriodEndDateChanged) {
                            this.applyChangesToTimeProperty(week.startDate, schedule, this.firstPeriodEndDate, 'firstPeriodEndDate');
                            isDirty = true;
                        }
                    } else {
                        this.applyChangesToTimeProperty(week.startDate, schedule, null, 'firstPeriodStartDate');
                        this.applyChangesToTimeProperty(week.startDate, schedule, null, 'firstPeriodEndDate');
                    }

                    if (hasSecondPeriod) {
                        if (this.secondPeriodStartDateChanged) {
                            this.applyChangesToTimeProperty(week.startDate, schedule, this.secondPeriodStartDate, 'secondPeriodStartDate');
                            isDirty = true;
                        }
                        if (this.secondPeriodEndDateChanged) {
                            this.applyChangesToTimeProperty(week.startDate, schedule, this.secondPeriodEndDate, 'secondPeriodEndDate');
                            isDirty = true;
                        }
                    } else {
                        this.applyChangesToTimeProperty(week.startDate, schedule, null, 'secondPeriodStartDate');
                        this.applyChangesToTimeProperty(week.startDate, schedule, null, 'secondPeriodEndDate');
                    }

                    if (this.lunchChanged) {
                        this.applyChangesToBoolProperty(schedule, this.lunch, 'lunch');
                    }

                    if (this.firstSnackChanged) {
                        this.applyChangesToBoolProperty(schedule, this.firstSnack, 'firstSnack');
                    }
                    if (this.secondSnackChanged) {
                        this.applyChangesToBoolProperty(schedule, this.secondSnack, 'secondSnack');
                    }
                    if (this.notesChanged) {
                        this.applyChangesToStringProperty(schedule,  this.notes, 'notes');
                    }
                    if (this.firstPeriodCapacityChanged) {
                        this.applyChangesToNumberProperty(schedule, this.firstPeriodCapacity, 'firstPeriodCapacity');
                    }
                    if (this.secondPeriodCapacityChanged) {
                        this.applyChangesToNumberProperty(schedule, this.secondPeriodCapacity, 'secondPeriodCapacity');
                    }

                    if (isDirty && !schedule.activityScheduleID) {
                        week.schedules.push(schedule);
                    }
                }

                this.firstPeriodStartDateChanged = false;
                this.firstPeriodEndDateChanged = false;
                this.secondPeriodStartDateChanged = false;
                this.secondPeriodEndDateChanged = false;
                this.lunchChanged = false;
                this.firstSnackChanged = false;
                this.secondSnackChanged = false;
                this.notesChanged = false;
                this.firstPeriodCapacityChanged = false;
                this.secondPeriodCapacityChanged = false;
            }
        }
    }

    ns.ScheduleDetailDay.prototype.applyChangesToTimeProperty = function (startDate, schedule, value, propertyName) {
        if (value) {
            var mvalue = moment(value);
            var nvalue = moment(startDate)
                    .add('days', this.dayOfWeek - 1)
                    .add('hours', mvalue.hour())
                    .add('minutes', mvalue.minute())
                    .toDate();
            schedule[propertyName] = nvalue;
        } else {
            schedule[propertyName] = null;
        }
    }

    ns.ScheduleDetailDay.prototype.applyChangesToBoolProperty = function (schedule, value, propertyName) {
        schedule[propertyName] = value || false;
    }

    ns.ScheduleDetailDay.prototype.applyChangesToStringProperty = function (schedule, value, propertyName) {
        schedule[propertyName] = value;
    }

    ns.ScheduleDetailDay.prototype.applyChangesToNumberProperty = function (schedule, value, propertyName) {
        schedule[propertyName] = value;
    }

    ns.ScheduleDetailDay.prototype.setCommonPropertyValue = function (startDate, schedule, propertyName) {
        var value = this.day[propertyName];

        if (value !== "indeterminate") {
            var timeCompare = schedule[propertyName] instanceof Date ||
                value instanceof Date;

            if (timeCompare && !!value) {
                value = moment(startDate)
                            .add('days', this.dayOfWeek - 1)
                            .add('hours', moment(value).hour())
                            .add('minutes', moment(value).minute())
                            .toDate();
            }

            if (timeCompare) {
                if (!schedule[propertyName] ||
                    !value ||
                    schedule[propertyName].getTime() !== value.getTime()) {
                    schedule[propertyName] = value;
                    schedule.dirty = true;
                }
            } else {
                if (schedule[propertyName] != value) {
                    var wasUndef = (typeof schedule[propertyName] === 'undefined');
                    schedule[propertyName] = value;
                    if (!wasUndef || (wasUndef && value)) {
                        schedule.dirty = true;
                    }
                }
            }
        }
    }

    ns.ScheduleDetailDay.prototype.getCommonPropertyValue = function (scheduleWeeks, propertyName, timeCompare) {
        var propertyValue = null;
        var firstRun = true;

        if (scheduleWeeks) {
            for (var w = 0; w < scheduleWeeks.length; w++) {
                var activityWeek = scheduleWeeks[w];

                var schedule = activityWeek.getScheduleByDay(this.dayOfWeek);
                if (!schedule) {
                    if (!firstRun) {
                        if (!propertyValue) {
                            return null;
                        }

                        return "indeterminate";
                    }

                    firstRun = false;
                    continue;
                }

                var schedulePropertyValue = schedule[propertyName];
                var same = null;

                if (timeCompare && propertyValue && schedulePropertyValue) {
                    var mPropertValue = moment(propertyValue);
                    var mSchedulePropertyValue = moment(schedulePropertyValue);

                    same = mPropertValue.hour() === mSchedulePropertyValue.hour() &&
                           mPropertValue.minute() === mSchedulePropertyValue.minute();
                } else {
                    same = propertyValue === schedulePropertyValue
                }

                if (!same) {
                    if (firstRun) {
                        if (timeCompare) {
                            propertyValue = new Date(schedulePropertyValue.valueOf())
                        } else {
                            propertyValue = schedulePropertyValue;
                        }
                        firstRun = false;
                    } else {
                        return "indeterminate";
                    }
                }
            }
        }

        return propertyValue;
    }
    // #endregion 

    // #region ScheduleDetailDay - Properties
    Object.defineProperty(ns.ScheduleDetailDay.prototype, "active", {
        get: function () {
            return this._active;
        },
        set: function (value) {

            this._active = value;

            if (!value) {
                this.firstPeriodStartDate = null;
                this.firstPeriodEndDate = null;
                this.secondPeriodStartDate = null;
                this.secondPeriodEndDate = null;
                this.lunch = false;
                this.firstSnack = false;
                this.secondSnack = false;
                this.notes = null;
                this.firstPeriodCapacity = 0;
                this.secondPeriodCapacity = 0;
            } else {
                var filled = this.parentDetail.getPrevFilledInDay(this);
                if (filled) {
                    this.firstPeriodStartDate = filled.firstPeriodStartDate;
                    this.firstPeriodEndDate = filled.firstPeriodEndDate;
                    this.secondPeriodStartDate = filled.secondPeriodStartDate;
                    this.secondPeriodEndDate = filled.secondPeriodEndDate;
                    this.lunch = filled.lunch;
                    this.firstSnack = filled.firstSnack;
                    this.secondSnack = filled.secondSnack;
                    this.notes = filled.notes;
                    this.firstPeriodCapacity = filled.firstPeriodCapacity;
                    this.secondPeriodCapacity = filled.secondPeriodCapacity;
                }
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleDetailDay.prototype, "firstPeriodStartDate", {
        get: function () {
            return this._firstPeriodStartDate;
        },
        set: function (value) {
            this._firstPeriodStartDate = value;
            this.firstPeriodStartDateChanged = true;
            if (value !== undefined) {
                this.firstPeriodStartDateIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleDetailDay.prototype, "firstPeriodEndDate", {
        get: function () {
            return this._firstPeriodEndDate;
        },
        set: function (value) {
            this._firstPeriodEndDate = value;
            this.firstPeriodEndDateChanged = true;
            if (value !== undefined) {
                this.firstPeriodEndDateIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleDetailDay.prototype, "secondPeriodStartDate", {
        get: function () {
            return this._secondPeriodStartDate;
        },
        set: function (value) {
            this._secondPeriodStartDate = value;
            this.secondPeriodStartDateChanged = true;
            if (value !== undefined) {
                this.secondPeriodStartDateIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleDetailDay.prototype, "secondPeriodEndDate", {
        get: function () {
            return this._secondPeriodEndDate;
        },
        set: function (value) {
            this._secondPeriodEndDate = value;
            this.secondPeriodEndDateChanged = true;
            if (value !== undefined) {
                this.secondPeriodEndDateIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleDetailDay.prototype, "lunch", {
        get: function () {
            return this._lunch;
        },
        set: function (value) {
            this._lunch = value;
            this.lunchChanged = true;
            if (value !== undefined) {
                this.lunchIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleDetailDay.prototype, "firstSnack", {
        get: function () {
            return this._firstSnack;
        },
        set: function (value) {
            this._firstSnack = value;
            this.firstSnackChanged = true;
            if (value !== undefined) {
                this.firstSnackIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleDetailDay.prototype, "secondSnack", {
        get: function () {
            return this._secondSnack;
        },
        set: function (value) {
            this._secondSnack = value;
            this.secondSnackChanged = true;
            if (value !== undefined) {
                this.secondSnackIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleDetailDay.prototype, "notes", {
        get: function () {
            return this._notes;
        },
        set: function (value) {
            this._notes = value;
            this.notesChanged = true;
            if (value !== undefined) {
                this.notesIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleDetailDay.prototype, "firstPeriodCapacity", {
        get: function () {
            return this._firstPeriodCapacity;
        },
        set: function (value) {
            if (!value) {
                value = 0;
            }
            this._firstPeriodCapacity = value;
            this.firstPeriodCapacityChanged = true;
            if (value !== undefined) {
                this.firstPeriodCapacityIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });


    Object.defineProperty(ns.ScheduleDetailDay.prototype, "secondPeriodCapacity", {
        get: function () {
            return this._secondPeriodCapacity;
        },
        set: function (value) {
            if (!value) {
                value = 0;
            }
            this._secondPeriodCapacity = value;
            this.secondPeriodCapacityChanged = true;
            if (value !== undefined) {
                this.secondPeriodCapacityIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    // #endregion


}(webooker_acivity_models));